const getOktaAccessToken = (): string => {
  const oktaCookie: string | null = localStorage.getItem("okta-token-storage");
  let accessToken: string = "";

  if (oktaCookie) {
    const token = JSON.parse(oktaCookie);
    accessToken = token.accessToken!.accessToken;
  }
  //TODO: implement refresh token logic if token expires
  return accessToken;
};

export { getOktaAccessToken };
